export default __webpack_public_path__ + "static/media/grey_rock_ground.039fb7ba.jpg";